import React from "react";
import { connect } from "react-redux";
import { Tab } from "semantic-ui-react";
import _ from "lodash";
import "../../assets/styles/sub-table.css";
import SearchResultHeader from "./SearchResultHeader";
import tableWithPagination from "../common/TableWithPagination";
import settings from "../../settings";
import { getPersonRecordData } from "./PersonRecordData";
import { getPersonDetailElement } from "./PersonDetailElement";
import { getMenuItem } from "../common/PageHelper";

class PersonSearchResult extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedReportId: undefined,
      activeIndex: 0,
    };
    this.loadData(props);
  }

  componentDidMount() {
    window.addEventListener("resize", this.updateDimensions);
  }

  componentWillReceiveProps(nextProps) {
    const selectedRows = [];
    for (let index = 0; index < nextProps.resultRecordCount; index += 1) {
      selectedRows[index] = false;
    }
    this.setState({
      selectedRows,
      selectedReportId: 0,
    });
  }

  onSelectPersonReport = (selectedReportId) => {
    this.setState({ selectedReportId });
  };

  onColumnMatch = (data) => {
    const { searchText, row } = data;
    if (searchText === "") return true;
    if (
      row.searchText
        .toLocaleLowerCase()
        .indexOf(searchText.toLocaleLowerCase()) !== -1
    )
      return true;
    return false;
  };

  getRevealSsnReportCost = () => {
    let revealSsnReportCost = "$0.00";
    if (this.props.uiData && this.props.uiData.Reports) {
      const revealSsnReport = _.find(
        this.props.uiData.Reports,
        (r) => r.ReportID === settings.revealSsnReportId
      );
      if (revealSsnReport) {
        const searchResultCost = revealSsnReport.SearchResultCost.toLowerCase();
        if (searchResultCost !== "included" && searchResultCost !== "free") {
          revealSsnReportCost = searchResultCost;
        }
      }
    }
    return revealSsnReportCost;
  };

  tabChange = (e, data) => {
    this.setState({ activeIndex: data.activeIndex });
  };

  personRecordFormatter = (
    cell,
    row,
    reportId,
    selectedReportId,
    props,
    revealSsnReportCost,
    onSelectPersonReport,
    isSilverSearch,
    isGoldSearch,
    showDetailReport
  ) =>
    getPersonDetailElement(
      row,
      reportId,
      selectedReportId,
      props,
      revealSsnReportCost,
      onSelectPersonReport,
      isSilverSearch,
      isGoldSearch,
      showDetailReport
    );

  loadData = (props) => {
    let tabHeader = null;
    const rows = [];
    const exactMatchrows = [];
    const possibleMatchrows = [];
    let reportId;
    let isSilverSearch;
    let isGoldSearch;
    let showDetailReport;
    if (
      props.searchResultData !== undefined &&
      props.searchResultData !== null &&
      props.searchResultData !== ""
    ) {
      let personResults = _.get(
        props.searchResultData,
        `${Object.keys(props.searchResultData)[0]}.person`
      );
      if (personResults === undefined) {
        personResults = _.get(
          props.searchResultData,
          `${Object.keys(props.searchResultData)[0]}.persons[0].person`
        );
      }
      if (personResults === undefined) {
        personResults = _.get(
          props.searchResultData,
          `${Object.keys(props.searchResultData)[0]}.response[0].person`
        );
      }
      if (personResults === undefined) {
        personResults = _.get(
          props.searchResultData,
          `${Object.keys(props.searchResultData)[0]
          }.response[0].output[0].people[0].person`
        );
      }
      if (personResults !== undefined) {
        const root = Object.keys(props.searchResultData)[0];
        const acctType = _.get(
          props.searchResultData,
          `${root}.log[0].actType[0]`,
          ""
        );
        reportId = parseInt(
          _.get(props.searchResultData, `${root}.log[0].reportID[0]`, "0"),
          10
        );
        localStorage.historyReportId = reportId;
        localStorage.historyCriteria = _.get(
          props.searchResultData,
          `${root}.log[0].actDesc[0]`
        );
        localStorage.xmlId = _.get(
          props.searchResultData,
          `${root}.log[0].xmlID[0]`
        );
        localStorage.actCode = _.get(
          props.searchResultData,
          `${root}.log[0].actCode[0]`
        );
        isSilverSearch = acctType.toLowerCase().indexOf("livesilver") > -1;
        isGoldSearch =
          settings.newMartinTemplate.includes(
            Object.keys(props.searchResultData)[0]
          ) ||
          // Object.keys(props.searchResultData)[0] === "nimbuspersons" ||
          acctType.toLowerCase().indexOf("persongold") > -1; // ||
        // acctType.toLowerCase().indexOf("live") > -1;
        let isViewReport = false;
        _.forEach(settings.viewReports, (viewReport) => {
          if (!isViewReport && acctType.toLowerCase().indexOf(viewReport) > -1)
            isViewReport = true;
        });
        let isViewDetailReport = false;
        _.forEach(settings.viewDetailReportRoots, (viewDetailReportRoot) => {
          if (
            !isViewDetailReport &&
            root.toLowerCase() === viewDetailReportRoot
          )
            isViewDetailReport = true;
        });
        showDetailReport = isViewDetailReport && !isViewReport;
        const showNarrowSearchMessage =
          personResults &&
          personResults.length > 25 &&
          (acctType.indexOf("Person") !== -1 ||
            acctType.indexOf("People") !== -1) &&
          acctType.indexOf("Enhanced") === -1;
        if (!(props.isSubSection && props.isSubSection === true))
          tabHeader = (
            <SearchResultHeader
              showNarrowSearchMessage={showNarrowSearchMessage}
              log={_.get(
                props.searchResultData,
                `${Object.keys(props.searchResultData)[0]}.log[0]`
              )}
              {...props}
              printContent={props.printContent}
            />
          );
        if (personResults.length > 0) {
          let sortedPersonResults = _.orderBy(personResults, (o) =>
            parseInt(_.get(o, "$.penalty"), 10)
          );
          sortedPersonResults = _.orderBy(sortedPersonResults, (r) =>
            parseInt(_.get(r, "$.internalID"), 10)
          );

          _.forEach(sortedPersonResults, (personRes) => {
            const personData = getPersonRecordData(
              personRes,
              props,
              isSilverSearch,
              isGoldSearch
            );
            const internalID = _.get(personRes, "$.internalID");
            if (props.formData.internalID === internalID) {
              rows.unshift(personData);
            } else {
              rows.push(personData);
            }
            const weight = _.get(personRes, "$.weight", "");
            if (weight !== "") {
              if (parseInt(weight, 10) === 100) {
                exactMatchrows.push(personData);
              } else {
                possibleMatchrows.push(personData);
              }
            }
          });
        }
      } else {
        const log = _.get(
          props.searchResultData,
          `${Object.keys(props.searchResultData)[0]}.log[0]`
        );
        if (log) {
          const error = _.get(props.searchResultData,
            `${Object.keys(props.searchResultData)[0]}.response[0].meta[0].errors[0].error[0]._`);
            if(error !== undefined) {
              tabHeader = (
                <SearchResultHeader
                  log={log}
                  {...props}
                  vendorError={error}
                  printContent={props.printContent}
                />
              );
            } else {
              tabHeader = (
                <SearchResultHeader
                  log={log}
                  {...props}
                  printContent={props.printContent}
                />
              );
            }
          }
        }
    }
    this.state = {
      tabHeader,
      rows,
      exactMatchrows,
      possibleMatchrows,
      reportId,
      isSilverSearch,
      isGoldSearch,
      showDetailReport,
      activeIndex: 0,
    };
  };

  render() {
    const {
      reportId,
      tabHeader,
      rows,
      exactMatchrows,
      possibleMatchrows,
      activeIndex,
    } = this.state;
    const { userAccount } = this.props;
    const revealSsnReportCost = this.getRevealSsnReportCost();
    const columns = [
      {
        dataField: "persRec",
        text: "",
        formatter: (cell, row) =>
          this.personRecordFormatter(
            cell,
            row,
            reportId,
            this.state.selectedReportId,
            this.props,
            revealSsnReportCost,
            this.onSelectPersonReport,
            this.state.isSilverSearch,
            this.state.isGoldSearch,
            this.state.showDetailReport
          ),
        sort: false,
      },
    ];

    if (!(this.props.isSubSection && this.props.isSubSection === true)) {
      const tabs = [];
      tabs.push({
        menuItem: getMenuItem(
          userAccount.acctTheme,
          activeIndex === 0,
          `${rows.length} Matches Found`
        ),
        render: () => (
          <Tab.Pane>
            {tabHeader}
            {tableWithPagination(
              "internalID",
              columns,
              rows,
              this.onColumnMatch
            )}
          </Tab.Pane>
        ),
      });
      if (Object.keys(this.props.searchResultData)[0] === "persons") {
        tabs.push({
          menuItem: getMenuItem(
            userAccount.acctTheme,
            activeIndex === 1,
            `${exactMatchrows.length} Exact Matches`
          ),
          render: () => (
            <Tab.Pane>
              {tabHeader}
              {tableWithPagination(
                "internalID",
                columns,
                exactMatchrows,
                this.onColumnMatch
              )}
            </Tab.Pane>
          ),
        });

        tabs.push({
          menuItem: getMenuItem(
            userAccount.acctTheme,
            activeIndex === 2,
            `${possibleMatchrows.length} Possible Matches`
          ),
          render: () => (
            <Tab.Pane>
              {tabHeader}
              {tableWithPagination(
                "internalID",
                columns,
                possibleMatchrows,
                this.onColumnMatch
              )}
            </Tab.Pane>
          ),
        });
      }

      return (
        <Tab
          panes={tabs}
          onTabChange={this.tabChange}
          activeIndex={activeIndex}
        />
      );
    }
    return <span />;
  }
}

function mapStateToProps(state) {
  return { userAccount: state.userAccount, uiData: state.uiData };
}

export default connect(mapStateToProps, null)(PersonSearchResult);



// WEBPACK FOOTER //
// ./src/components/searchresults/PersonSearchResult.js